import { render, staticRenderFns } from "./PostEntries.vue?vue&type=template&id=2f98fd37"
import script from "./PostEntries.vue?vue&type=script&lang=js"
export * from "./PostEntries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports